import {
	SET_FORMS,
	CLEAR_FORMS,
	SET_RELOAD_FORMS,
	SET_RESET_VALUE,
	SET_CURRENT_CUSTOMERS_FORMS,
	TOAST_MESSAGES_PUSH
} from './mutation-types';
import { ApiService as api } from '@/services/axiosHelper';

import _ from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'forms',
	namespaced: true,
	state: {
		forms: {},
		reloadForms: false,
		resetValue: false,
		currentCustomers: []
	},
	mutations: {
		[SET_FORMS](state, data) {
			if (!Object.keys(state.forms).length) {
				state.forms = data;
			} else {
				if (data.saveOnStore) {
					const currentItems = _.cloneDeep(state.forms.items).concat(
						data.items
					);
					state.forms = {
						...data,
						items: currentItems
					};
				} else {
					state.forms = data;
				}
			}
		},
		[CLEAR_FORMS](state) {
			state.forms = {};
		},
		[SET_RELOAD_FORMS](state, value) {
			state.reloadForms = value;
		},
		[SET_RESET_VALUE](state, value) {
			state.resetValue = value;
		},
		[SET_CURRENT_CUSTOMERS_FORMS](state, value) {
			state.currentCustomers = value;
		}
	},
	actions: {
		async loadForms({ dispatch, commit }, params) {
			
			const { saveOnStore } = params;
			
			return new Promise((resolve, reject) => {
				api.get('/forms', { params })
					.then(res => {
						if (params.page === 1) {
							commit(CLEAR_FORMS);
						}

						commit(SET_FORMS, { ...res, saveOnStore });
						commit(SET_RELOAD_FORMS, false);
						resolve();
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		reloadForms({ commit }, value) {
			commit(SET_RELOAD_FORMS, value);
		},
		resetValue({ commit }, value) {
			commit(SET_RESET_VALUE, value);
		},
		currentCustomers({ commit }, value) {
			commit(SET_CURRENT_CUSTOMERS_FORMS, value);
		}
	},
	getters: {
		forms: state => state.forms,
		reloadForms: state => state.reloadForms,
		resetValue: state => state.resetValue,
		currentCustomers: state => state.currentCustomers,
		formTypeById: state => id =>
			state.forms.items.find(form => form.id === id).formPrintType
	}
};
